var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgCheckCircle = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5337 11.5971C20.5337 11.1926 20.8616 10.8646 21.2662 10.8646C21.6707 10.8646 21.9987 11.1926 21.9987 11.5971V12.5059C21.996 17.1557 18.9353 21.2499 14.4763 22.5683C10.0173 23.8867 5.22224 22.1151 2.69145 18.2144C0.160657 14.3136 0.496999 9.21289 3.51808 5.67823C6.53916 2.14357 11.5253 1.01701 15.7726 2.90949C16.1421 3.07414 16.3082 3.50718 16.1435 3.87671C15.9789 4.24624 15.5458 4.41233 15.1763 4.24768C11.5217 2.61927 7.23128 3.58863 4.63175 6.63008C2.03221 9.67154 1.7428 14.0606 3.92046 17.417C6.09812 20.7735 10.2241 22.2978 14.0609 21.1634C17.8977 20.029 20.5314 16.506 20.5337 12.5054V11.5971ZM11.4994 13.4229L21.7249 3.19735C22.0109 2.91129 22.4747 2.91129 22.7608 3.19735C23.0469 3.48342 23.0469 3.94722 22.7608 4.23328L12.0173 14.9768C11.7313 15.2628 11.2675 15.2628 10.9814 14.9768L8.05136 12.0467C7.7653 11.7607 7.7653 11.2969 8.05136 11.0108C8.33743 10.7247 8.80123 10.7247 9.08729 11.0108L11.4994 13.4229Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgCheckCircle;